
// export const BASEDOMAIN = 'http://192.168.1.119:8888'

export const BASEDOMAIN = 'https://www.shyfxxkj.com'
